<template>
  <div id="strategie">
    <section class="section section-lg">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div
            class="col-md-6 order-md-2"
            data-aos="fade-up"
            data-aos-duration="1300"
          >
            <img
              src="img/theme/celtiis/velopub.jpg"
              alt="panneau mobile, votre vélo publicitaire, image régie publicitaire, image street marketing"
              class="img-fluid floating"
            />
          </div>

          <div
            class="col-md-6 order-md-1"
            data-aos="fade-left"
            data-aos-duration="1300"
          >
            <div class="pr-md-5">
              <icon
                name="ni ni-settings-gear-65"
                class="mb-5"
                size="lg"
                type="success"
                shadow
                rounded
              ></icon>
              <h3>Atouts de Panneau Mobile</h3>
              <p>
                Panneau Mobile incarne une nouvelle forme de publicité
                extérieure hybride combinant à la fois les atouts de l’affichage
                classique et ceux du street Marketing.
              </p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="ni ni-check-bold"
                    ></badge>
                    <h6 class="mb-0">
                      Un affichage mobile au cœur des zones piétonnes
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="ni ni-check-bold"
                    ></badge>
                    <h6 class="mb-0">
                      Un affichage tactique qui va là où aucun autre réseau ne
                      peut aller
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="ni ni-check-bold"
                    ></badge>
                    <h6 class="mb-0">
                      Un affichage de proximité pour émerger en zone de
                      chalandise
                    </h6>
                  </div>
                </li>

                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="ni ni-check-bold"
                    ></badge>
                    <h6 class="mb-0">
                      Un support sans polution de l'environnement
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="ni ni-check-bold"
                    ></badge>
                    <h6 class="mb-0">
                      Un taux d’attention de 76% et de 59% de mémorisation
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="ni ni-check-bold"
                    ></badge>
                    <h6 class="mb-0">
                      Une gamme variée de formats originaux et innovants
                    </h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
};
</script>
<style></style>
